<template>
    <tr>
        <td class="text-left" :class="{'pl-4':child}"><label><input type="checkbox" @change="moduleAll()"
                                                                    v-model="section.module"> {{ section.name }}</label>
        </td>
        <td class="text-center"><label><input type="checkbox" v-model="section.actions.view"> View</label></td>
        <td class="text-center"><label><input type="checkbox" v-model="section.actions.create"> Create</label></td>
        <td class="text-center"><label><input type="checkbox" v-model="section.actions.update"> Update</label></td>
        <td class="text-center"><label><input type="checkbox" v-model="section.actions.delete"> Delete</label></td>
        <td class="text-center"><label><input type="checkbox" v-model="section.actions.index"> Index</label></td>
    </tr>
</template>

<script>

export default {
    name: "Section",
    props: {
        section: {
            type: Object,
            default: {}
        },
        parent: {
            type: Object,
            required: false
        },
        child: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    watch: {

        'section.actions.view'(val) {
            this.$emit('checkModule', this.section, this.parent)
        },
        'section.actions.create'(val) {
            if (val) this.section.actions.view = true;
            this.$emit('checkModule', this.section, this.parent)
        },
        'section.actions.update'(val) {
            if (val) this.section.actions.view = true;
            this.$emit('checkModule', this.section, this.parent)
        },
        'section.actions.delete'(val) {
            if (val) this.section.actions.view = true;
            this.$emit('checkModule', this.section, this.parent)
        },
        'section.actions.index'(val) {
            if (val) this.section.actions.view = true;
            this.$emit('checkModule', this.section, this.parent)
        }
    },
    mounted() {

    },
    methods: {
        moduleAll(){
            this.$emit('moduleAll', this.section, this.parent)
        }
    }
}
</script>

<style scoped>

</style>
